import React from 'react'
import PropTypes from 'prop-types'

import { Grid, Segment } from 'semantic-ui-react'
import { compose } from 'recompose'

import Enhancer from './FamilyAlbumModuleEnhancer'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'
import { withPermissions } from 'Components/Permissions'

import ErrorMassive from 'Components/ErrorMassive'
import FAEventCard from 'Components/FAEventCard'
import FACardGroup from 'Components/FACardGroup'
import FASearchForm from 'Components/FASearchForm'
import PageHeaderRow from 'Components/PageHeaderRow'

import * as styles from './styles'

const FamilyAlbumModule = props => {
  const { events, exportToExcel } = props

  const mappedEvents = events.map(event => {
    return <FAEventCard event={event} exportToExcel={exportToExcel} key={event.id} />
  })

  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width={4}>
          <div style={styles.header}>
            <PageHeaderRow title="Family Album" />
          </div>
          <div style={styles.form}>
            <Grid.Row>
              <FASearchForm shouldRedirectToSearch />
            </Grid.Row>
          </div>
        </Grid.Column>

        <Grid.Column width={12}>
          <Segment style={styles.rugCardsSegment}>
            <FACardGroup>{mappedEvents}</FACardGroup>

            <ErrorMassive enabled={events.length === 0} message="No events found." />
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

FamilyAlbumModule.propTypes = {
  events: PropTypes.array.isRequired,
  exportToExcel: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  loaderPending: PropTypes.bool.isRequired,
}

const composed = compose(
  withPermissions('modules.familyAlbum'),
  Enhancer,
  StandardLoader('Counting the events…'),
  StandardError,
)

export default composed(FamilyAlbumModule)
